import _ from 'lodash';
import {
  GET_NOTE_LIST_SUCCESS,
  CREATE_NOTE_ITEM_SUCCESS,
  CREATE_NOTE_ITEM_ERROR,
  TOGGLE_NOTE_LIST_LOADING,
  DELETE_NOTE_ITEM_SUCCESS,
  EDIT_NOTE_ITEM,
  CANCEL_EDIT_NOTE_ITEM,
  UPDATE_NOTE_ITEM_SUCCESS,
} from './actions';
import { CLEAR_DATA } from '../actions';

const initState = {
  notes: [],
  offset: 0,
  pageSize: 15,
  isLoading: false,
  hasError: false,
  error: null,
  isEditing: false,
  editID: null,
};

const noteListReducer = (state = initState, action) => {
  // console.log('noteListReducer', state, action);

  const { type, payload } = action;
  switch (type) {
    case GET_NOTE_LIST_SUCCESS: {
      const { response } = payload;
      return {
        ...state,
        notes: response,
        hasError: false,
        error: null,
      };
    }

    case CREATE_NOTE_ITEM_SUCCESS: {
      const { response } = payload;
      const { notes } = state;
      const newNoteList = _.concat([response], notes);
      return {
        ...state,
        notes: newNoteList,
        hasError: false,
        error: null,
      };
    }

    case CREATE_NOTE_ITEM_ERROR: {
      const { error } = payload;
      return {
        ...state,
        hasError: true,
        error,
      };
    }

    case DELETE_NOTE_ITEM_SUCCESS: {
      const { id } = payload;
      const { notes } = state;
      const newNoteList = _.filter(notes, item => item.id !== id);
      return {
        ...state,
        notes: newNoteList,
      };
    }

    case TOGGLE_NOTE_LIST_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        isLoading,
      };
    }

    case EDIT_NOTE_ITEM: {
      const { id } = payload;
      return {
        ...state,
        isEditing: true,
        editID: id,
      };
    }

    case CANCEL_EDIT_NOTE_ITEM: {
      return {
        ...state,
        isEditing: false,
        editID: null,
      };
    }

    case UPDATE_NOTE_ITEM_SUCCESS: {
      const { response } = payload;
      const { notes } = state;
      const filtereddNote = _.filter(notes, item => item.id !== response.id);
      const newNoteList = _.concat([response], filtereddNote);
      return {
        ...state,
        isEditing: false,
        editID: null,
        notes: newNoteList,
      };
    }

    case CLEAR_DATA:
      return initState;

    default:
      return state;
  }
};

export default noteListReducer;
